import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { LegendsComponent } from 'src/app/pages/history/legends/legends.component';
import { DisplayOrdersComponent } from '../../check/display-orders/display-orders.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-order-number',
    templateUrl: './order-number.component.html',
    styleUrls: ['./order-number.component.scss'],
    standalone: false // NOSONAR
})
export class OrderNumberComponent implements ICellRendererAngularComp {
  public params: any;
  public comment: string;
  public shortenedComment: string;
  show: boolean = false;
  trimmedComment: string;
  btnVisible: boolean = false;
  type: string;

  constructor(  private readonly dialog : MatDialog) { }

  // ngOnInit(): void {
  // }

  agInit(params: any): void {

    this.params = params;
    this.type = this.params.field;
    if (this.params.field == "order_number") { // NOSONAR
      this.comment = params.data?.order_number;
    } else if (this.params.field == "part_number") { // NOSONAR
      this.comment = params.data?.part_number;
    } else if (this.params.field == "kanban_number") { // NOSONAR
      this.comment = params.data?.kanban_number;
    }
    if (this.comment != null && this.comment != '' && this.comment != undefined) {  // NOSONAR
      if (this.comment.length > 15) {
        this.btnVisible = true;
        this.trimmedComment = this.comment.substring(0, 15);
      }
      else {
        this.btnVisible = false;
        this.trimmedComment = this.comment;
      }
      this.shortenedComment = this.trimmedComment;
    } else {
      this.btnVisible = false;
      this.trimmedComment = '';
      this.shortenedComment = '';
    }
  }

  openOrders(event:MouseEvent){
    event.stopPropagation();
    this.dialog?.open(DisplayOrdersComponent, {
      width: '600px',
      data:{
        type:this.type,
        data:this.comment,
      }
    })
  }

  refresh(): boolean {
    return false;
  }


}
